import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const DesensitizationDisplayMeta: ComponentMeta = {
  componentName: "DesensitizationDisplay",
  package: "custom",
  title: "脱敏展示",
  description: "支持手机号/身份证脱敏显示与一键复制",
  category: ComponentCategory.DATA_DISPLAY,
  visibleInComponentPanel: true,
  icon: "SafetyCertificateOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "copyableText",
      label: "展示文本",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "type",
      label: "脱敏类型",
      type: PropType.ENUM,
      defaultValue: "idCard",
      options: [
        { label: "身份证", value: "idCard" },
        { label: "手机号", value: "phone" },
      ],
      group: "功能",
    },
  ],
  defaultProps: {
    type: "idCard",
  },
  preview: [
    {
      title: "手机号脱敏",
      props: {
        type: "phone",
        copyableText: "13800000000",
      },
    },
    {
      title: "身份证脱敏",
      props: {
        type: "idCard",
        copyableText: "110101199003070019",
      },
    },
  ],
  npm: {
    package: "@mijalowcode/materials",
    exportName: "DesensitizationDisplay",
  },
  snippet: {
    componentName: "DesensitizationDisplay",
    package: "custom",
    props: {
      type: "phone",
      copyableText: "13800000000",
    },
  },
};
